export const wechatEmojiMap: { [x: string]: string } = {
    '': '👦',
    '': '👧',
    '': '💋',
    '': '👨',
    '': '👩',
    '': '👕',
    '': '👟',
    '': '📷',
    '': '📞',
    '': '📱',
    '': '📠',
    '': '💻',
    '': '👊',
    '': '👍',
    '': '☝',
    '': '✊',
    '': '✌',
    '': '✋',
    '': '🎿',
    '': '⛳',
    '': '🎾',
    '': '⚾',
    '': '🏄',
    '': '⚽',
    '': '🐟',
    '': '🐴',
    '': '🚗',
    '': '⛵',
    '': '✈',
    '': '🚃',
    '': '🚅',
    '': '❓',
    '': '❗',
    '': '❤',
    '': '💔',
    '': '🕐',
    '': '🕑',
    '': '🕒',
    '': '🕓',
    '': '🕔',
    '': '🕕',
    '': '🕖',
    '': '🕗',
    '': '🕘',
    '': '🕙',
    '': '🕚',
    '': '🕛',
    '': '🌸',
    '': '🔱',
    '': '🌹',
    '': '🎄',
    '': '💍',
    '': '💎',
    '': '🏠',
    '': '⛪',
    '': '🏢',
    '': '🚉',
    '': '⛽',
    '': '🗻',
    '': '🎤',
    '': '🎥',
    '': '🎵',
    '': '🔑',
    '': '🎷',
    '': '🎸',
    '': '🎺',
    '': '🍴',
    '': '🍸',
    '': '☕',
    '': '🍰',
    '': '🍺',
    '': '⛄',
    '': '☁',
    '': '☀',
    '': '☔',
    '': '🌙',
    '': '🌄',
    '': '👼',
    '': '🐱',
    '': '🐯',
    '': '🐻',
    '': '🐶',
    '': '🐭',
    '': '🐳',
    '': '🐧',
    '': '😊',
    '': '😃',
    '': '😞',
    '': '😠',
    '': '💩',
    '': '📫',
    '': '📮',
    '': '📩',
    '': '📲',
    '': '😜',
    '': '😍',
    '': '😱',
    '': '😓',
    '': '🐵',
    '': '🐙',
    '': '🐷',
    '': '👽',
    '': '🚀',
    '': '👑',
    '': '💡',
    '': '🍀',
    '': '💏',
    '': '🎁',
    '': '🔫',
    '': '🔍',
    '': '🏃',
    '': '🔨',
    '': '🎆',
    '': '🍁',
    '': '🍂',
    '': '👿',
    '': '👻',
    '': '💀',
    '': '🔥',
    '': '💼',
    '': '💺',
    '': '🍔',
    '': '⛲',
    '': '⛺',
    '': '♨',
    '': '🎡',
    '': '🎫',
    '': '💿',
    '': '📀',
    '': '📻',
    '': '📼',
    '': '📺',
    '': '👾',
    '': '〽',
    '': '🀄',
    '': '🆚',
    '': '💰',
    '': '🎯',
    '': '🏆',
    '': '🏁',
    '': '🎰',
    '': '🐎',
    '': '🚤',
    '': '🚲',
    '': '🚧',
    '': '🚹',
    '': '🚺',
    '': '🚼',
    '': '💉',
    '': '💤',
    '': '⚡',
    '': '👠',
    '': '🛀',
    '': '🚽',
    '': '🔊',
    '': '📢',
    '': '🎌',
    '': '🔒',
    '': '🔓',
    '': '🌆',
    '': '🍳',
    '': '📘',
    '': '💱',
    '': '💹',
    '': '📡',
    '': '💪',
    '': '🏦',
    '': '🚥',
    '': '🅿',
    '': '🚏',
    '': '🚻',
    '': '👮',
    '': '🏣',
    '': '🏧',
    '': '🏥',
    '': '🏪',
    '': '🏫',
    '': '🏨',
    '': '🚌',
    '': '🚕',
    '': '🚶',
    '': '🚢',
    '': '🈁',
    '': '💟',
    '': '✴',
    '': '✳',
    '': '🔞',
    '': '🚭',
    '': '🔰',
    '': '♿',
    '': '📶',
    '': '♥',
    '': '♦',
    '': '♠',
    '': '♣',
    '': '#⃣',
    '': '➿',
    '': '🆕',
    '': '🆙',
    '': '🆒',
    '': '🈶',
    '': '🈚',
    '': '🈷',
    '': '🈸',
    '': '🔴',
    '': '🔲',
    '': '🔳',
    '': '1⃣',
    '': '2⃣',
    '': '3⃣',
    '': '4⃣',
    '': '5⃣',
    '': '6⃣',
    '': '7⃣',
    '': '8⃣',
    '': '9⃣',
    '': '0⃣',
    '': '🉐',
    '': '🈹',
    '': '🈂',
    '': '🆔',
    '': '🈵',
    '': '🈳',
    '': '🈯',
    '': '🈺',
    '': '👆',
    '': '👇',
    '': '👈',
    '': '👉',
    '': '⬆',
    '': '⬇',
    '': '➡',
    '': '⬅',
    '': '↗',
    '': '↖',
    '': '↘',
    '': '↙',
    '': '▶',
    '': '◀',
    '': '⏩',
    '': '⏪',
    '': '🔯',
    '': '♈',
    '': '♉',
    '': '♊',
    '': '♋',
    '': '♌',
    '': '♍',
    '': '♎',
    '': '♏',
    '': '♐',
    '': '♑',
    '': '♒',
    '': '♓',
    '': '⛎',
    '': '🔝',
    '': '🆗',
    '': '©',
    '': '®',
    '': '📳',
    '': '📴',
    '': '⚠',
    '': '💁',
    '': '📝',
    '': '👔',
    '': '🌺',
    '': '🌷',
    '': '🌻',
    '': '💐',
    '': '🌴',
    '': '🌵',
    '': '🚾',
    '': '🎧',
    '': '🍶',
    '': '🍻',
    '': '㊗',
    '': '🚬',
    '': '💊',
    '': '🎈',
    '': '💣',
    '': '🎉',
    '': '✂',
    '': '🎀',
    '': '㊙',
    '': '💽',
    '': '📣',
    '': '👒',
    '': '👗',
    '': '👡',
    '': '👢',
    '': '💄',
    '': '💅',
    '': '💆',
    '': '💇',
    '': '💈',
    '': '👘',
    '': '👙',
    '': '👜',
    '': '🎬',
    '': '🔔',
    '': '🎶',
    '': '💓',
    '': '💗',
    '': '💘',
    '': '💙',
    '': '💚',
    '': '💛',
    '': '💜',
    '': '✨',
    '': '⭐',
    '': '💨',
    '': '💦',
    '': '⭕',
    '': '❌',
    '': '💢',
    '': '🌟',
    '': '❔',
    '': '❕',
    '': '🍵',
    '': '🍞',
    '': '🍦',
    '': '🍟',
    '': '🍡',
    '': '🍘',
    '': '🍚',
    '': '🍝',
    '': '🍜',
    '': '🍛',
    '': '🍙',
    '': '🍢',
    '': '🍣',
    '': '🍏',
    '': '🍊',
    '': '🍓',
    '': '🍉',
    '': '🍅',
    '': '🍆',
    '': '🎂',
    '': '🍱',
    '': '🍲',
    '': '😥',
    '': '😏',
    '': '😔',
    '': '😁',
    '': '😉',
    '': '😣',
    '': '😖',
    '': '😪',
    '': '😝',
    '': '😌',
    '': '😨',
    '': '😷',
    '': '😳',
    '': '😒',
    '': '😰',
    '': '😲',
    '': '😭',
    '': '😂',
    '': '😢',
    '': '☺',
    '': '😄',
    '': '😡',
    '': '😚',
    '': '😘',
    '': '👀',
    '': '👃',
    '': '👂',
    '': '👄',
    '': '🙏',
    '': '👋',
    '': '👏',
    '': '👌',
    '': '👎',
    '': '👐',
    '': '🙅',
    '': '🙆',
    '': '💑',
    '': '🙇',
    '': '🙌',
    '': '👫',
    '': '👯',
    '': '🏀',
    '': '🏈',
    '': '🎱',
    '': '🏊',
    '': '🚙',
    '': '🚚',
    '': '🚒',
    '': '🚑',
    '': '🚓',
    '': '🎢',
    '': '🚇',
    '': '🚄',
    '': '🎍',
    '': '💝',
    '': '🎎',
    '': '🎓',
    '': '🎒',
    '': '🎏',
    '': '🌂',
    '': '💒',
    '': '🌊',
    '': '🍧',
    '': '🎇',
    '': '🐚',
    '': '🎐',
    '': '🌀',
    '': '🌾',
    '': '🎃',
    '': '🎑',
    '': '🍃',
    '': '🎅',
    '': '🌅',
    '': '🌇',
    '': '🌃',
    '': '🌈',
    '': '🏩',
    '': '🎨',
    '': '🎩',
    '': '🏬',
    '': '🏯',
    '': '🏰',
    '': '🎦',
    '': '🏭',
    '': '🗼',
    '': '🇯🇵',
    '': '🇺🇸',
    '': '🇫🇷',
    '': '🇩🇪',
    '': '🇮🇹',
    '': '🇬🇧',
    '': '🇪🇸',
    '': '🇷🇺',
    '': '🇨🇳',
    '': '🇰🇷',
    '': '👱',
    '': '👲',
    '': '👳',
    '': '👴',
    '': '👵',
    '': '👶',
    '': '👷',
    '': '👸',
    '': '🗽',
    '': '💂',
    '': '💃',
    '': '🐬',
    '': '🐦',
    '': '🐠',
    '': '🐣',
    '': '🐹',
    '': '🐛',
    '': '🐘',
    '': '🐨',
    '': '🐒',
    '': '🐑',
    '': '🐺',
    '': '🐮',
    '': '🐰',
    '': '🐍',
    '': '🐔',
    '': '🐗',
    '': '🐫',
    '': '🐸',
    '': '🅰',
    '': '🅱',
    '': '🆎',
    '': '🅾',
    '': '👣',
    '': '™'
}

export function wechatEmojify(content: string) {
    if (typeof content !== 'string') {
        throw new Error('wechatEmojify: content should be string')
    }
    if (content === '') return ''
    return content
        .split('')
        .map(char => (wechatEmojiMap[char] ? wechatEmojiMap[char] : char))
        .join('')
}

export default wechatEmojify
